<h1 class="title">{{ title | uppercase }}</h1>
